export default function IndexingIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="44"
      viewBox="0 0 26 44"
      fill="none"
    >
      <circle cx="21.5" cy="4.5" r="4.5" fill="currentColor" />
      <circle cx="4.5" cy="13.5" r="4.5" fill="currentColor" />
      <circle cx="21.5" cy="30.5" r="4.5" fill="currentColor" />
      <circle cx="4.5" cy="39.5" r="4.5" fill="currentColor" />
      <path
        d="M23 29.6182L5 40V12.5L23 3V29.6182Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-dasharray="2 2"
      />
    </svg>
  );
}
